import { render, staticRenderFns } from "./BookingPayments.vue?vue&type=template&id=26dbf20e&"
import script from "./BookingPayments.vue?vue&type=script&lang=js&"
export * from "./BookingPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports